import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import whoImg from '../assets/who.jpeg';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function WhoSection() {
  const navigate = useNavigate();
  return (
    <Box sx={{
      width: '100vw',
      maxWidth: '100vw',
      height: '100vh',
      minHeight: { xs: 420, md: 350, lg: 550 },
      bgcolor: '#fff',
      border: '1px solid #bdbdbd',
      boxSizing: 'border-box',
      py: { xs: 6, md: 8 },
      px: { xs: 1, md: 0 },
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      overflowX: 'hidden',
    }}>
      {/* Emoji and Heading */}
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: { xs: 8, sm: 2, md: 2, lg: 2 }, mt: { xs: 29, sm: 29, md: 29, lg: 29 } }}>
        <Box component="img" src={whoImg} alt="acne emoji" sx={{ width: 54, height: 54, objectFit: 'contain' }} />
        <Typography component="span" sx={{ fontWeight: 500, fontSize: { xs: 36, md: 54, lg: 84 }, color: '#0a716e', fontFamily: 'Neue Haas Grotesk Display Pro, Inter, Roboto, Arial, sans-serif' }}>
          acne,
        </Typography>
        <Typography component="span" sx={{ fontWeight: 500, fontSize: { xs: 36, md: 54, lg: 84 }, color: '#757575', fontFamily: 'Neue Haas Grotesk Display Pro, Inter, Roboto, Arial, sans-serif' }}>
          who?
        </Typography>
      </Stack>

      {/* Social and review */}
      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center" justifyContent="center" spacing={25} sx={{ mb: { xs: 2, sm: 0 , md: 2, lg: 2}, width: '100%', ml: { xs: 0, sm: 2, lg: 1 } }}>
        <Stack direction="row" alignItems="center" spacing={1.2} sx={{ mb: { xs: 1, sm: 0, md: 0, lg: 0 } }}>
          <a href="https://www.instagram.com/ixoriaherbalproject/" target="_blank" rel="noopener noreferrer">
            <InstagramIcon sx={{ fontSize: { xs: 18, sm: 29 }, color: '#0a716e' }} />
          </a>
          <a href="https://www.facebook.com/people/Ixoria-Herbal-Project/100091354385365/" target="_blank" rel="noopener noreferrer">
            <FacebookIcon sx={{ fontSize: { xs: 18, sm: 29 }, color: '#0a716e' }} />
          </a>
          <a href="https://x.com/projectixoria" target="_blank" rel="noopener noreferrer">
            <XIcon sx={{ fontSize: { xs: 18, sm: 29 }, color: '#0a716e' }} />
          </a>
          <a href="https://www.youtube.com/@ixoriaherbalproject" target="_blank" rel="noopener noreferrer">
            <YouTubeIcon sx={{ fontSize: { xs: 18, sm: 29 }, color: '#0a716e' }} />
          </a>
          <a href="https://www.linkedin.com/company/ixoriaherbalproject" target="_blank" rel="noopener noreferrer">
            <LinkedInIcon sx={{ fontSize: { xs: 18, sm: 29 }, color: '#0a716e' }} />
          </a>
          <a href="https://wa.me/918921074007" target="_blank" rel="noopener noreferrer">
            <WhatsAppIcon sx={{ fontSize: { xs: 18, sm: 29 }, color: '#0a716e' }} />
          </a>
          <Typography sx={{ fontWeight: 500, fontSize: { xs: 18, sm: 25 }, color: '#222', ml: 1, fontFamily: 'Neue Haas Grotesk Display Pro, Inter, Roboto, Arial, sans-serif' }}>
            @ixoriaherbalproject
          </Typography>
        </Stack>
        <Box
          role="button"
          tabIndex={0}
          onClick={() => navigate('/reviews')}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate('/reviews'); } }}
          sx={{
          background: '#ededed',
          borderRadius: 999,
          px: { xs: 2, sm: 3.5 },
          py: { xs: 1, sm: 2 },
          minWidth: { xs: 230, sm: 320 },
          display: 'flex',
          alignItems: 'center',
          display: 'inline',
          justifyContent: 'center',
          fontSize: { xs: 15, sm: 18, lg: 20 },
          fontFamily: 'Neue Haas Grotesk Display Pro, Inter, Roboto, Arial, sans-serif',
          boxShadow: 1,
          cursor: 'pointer',
          userSelect: 'none',
        }}
        >
          Share your <Box component="span" sx={{ fontWeight: 500}}> honest </Box> review with us :)
        </Box>
      </Stack>
      {/* Address */}
      <Typography sx={{ fontSize: { xs: 13, sm: 15, md: 17, lg: 25 }, color: '#222', fontFamily: 'Neue Haas Grotesk Display Pro, Inter, Roboto, Arial, sans-serif', textAlign: 'center', mb: { xs: 0, sm: 0.2, md: 0.2, lg: 0.2 } }}>
        Registered office : 68/1523,5th floor, CM Mathew Brothers Arcade, Chakkorathukulam, Calicut, Kerala, India 673011
      </Typography>
      <Typography sx={{ fontSize: { xs: 13, sm: 15, md: 17, lg: 25 }, color: '#222', fontFamily: 'Neue Haas Grotesk Display Pro, Inter, Roboto, Arial, sans-serif', textAlign: 'center' }}>
        Customer Support : +91-892 1074 007  Email : ixoriaherbalproject@gmail.com
      </Typography>
    </Box>
  );
}
